document.addEventListener("DOMContentLoaded", () => {
  
  const targetNode = document.querySelector('#cart-subtotal'); // Adjust the selector based on your DOM
  const config = { childList: true, subtree: true };
  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        //checkCartTotal();
      }
    });
  });
  
  // Start observing the cart subtotal
  if (targetNode) {
    observer.observe(targetNode, config);
  } else {
    console.error('Target node for MutationObserver not found!');
  }
  


    // Select the cart drawer element
    const cartDrawer = document.querySelector('.cart-drawer'); // Update selector as needed
    const body = document.body;

    // Function to add/remove class based on drawer state
    function toggleCartClass(isOpen) {
        if (isOpen) {
            body.classList.add('cart_drawer_opened');
        } else {
            body.classList.remove('cart_drawer_opened');
        }
    }

    // Event listener for opening the cart drawer
    document.querySelector('.open-cart-button').addEventListener('click', function () {
        toggleCartClass(true);
    });

    // Event listener for closing the cart drawer
    document.querySelector('.cart__drawer-header-close').addEventListener('click', function () {
        toggleCartClass(false);
    });


});

const strikeThroughPriceElements = document.querySelectorAll(".ctm-strike-through_price");

if (strikeThroughPriceElements.length > 0) {
    // Function to clean the text content
    const cleanTextContent = (element) => {
        if (element.textContent.startsWith("- ")) {
            element.textContent = element.textContent.replace(/^- /, '');
        }
    };


    strikeThroughPriceElements.forEach((element) => cleanTextContent(element));

    const observer = new MutationObserver(() => {
        document.querySelectorAll(".ctm-strike-through_price").forEach((element) => cleanTextContent(element));
    });

    strikeThroughPriceElements.forEach((element) => {
        observer.observe(element, {
            characterData: true,
            subtree: true,
            childList: true,
        });
    });

    const parentObserver = new MutationObserver(() => {
        document.querySelectorAll(".ctm-strike-through_price").forEach((element) => {
            if (!element._observed) {
                element._observed = true;
                cleanTextContent(element);
                observer.observe(element, {
                    characterData: true,
                    subtree: true,
                    childList: true,
                });
            }
        });
    });

    parentObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });
}



document.querySelector('.cart__drawer').addEventListener('touchmove', function (event) {
    event.stopPropagation(); // Prevent interference with other listeners
}, { passive: false });


document.addEventListener("DOMContentLoaded", function () {

  var swiperContainer_nav = document.querySelector(".ctm_nav_upsell_main");

    if (!swiperContainer_nav) return;

    var swiper_nav = new Swiper(swiperContainer_nav, {
      slidesPerView: 2.5, // Default setting
      spaceBetween: 20,
      navigation: {
        nextEl: ".remedy_nav_next",
        prevEl: ".remedy_nav_prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 5.5,
        },
        768: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 1,
        },
      },
      on: {
        resize: function () {
          if (swiper_nav) swiper_nav.update(); // Force Swiper to recalculate slides
        },
      },
    });
});
  


document.addEventListener("DOMContentLoaded", function () {
  const accordionTitles = document.querySelectorAll('.main_ctm_child_link');

  accordionTitles.forEach((titleEl) => {
    titleEl.addEventListener('click', function () {
      const contentEl = titleEl.nextElementSibling;
      const arrowImg = titleEl.querySelector('.main_accordion_arrow');
      const isOpen = contentEl.classList.contains('open');

      document.querySelectorAll('.main_accordion_content').forEach((panel) => {
        panel.classList.remove('open');
        panel.style.maxHeight = null;
      });

      accordionTitles.forEach((el) => el.classList.remove('active'));

      document.querySelectorAll('.main_accordion_arrow').forEach((img) => {
        img.style.transform = 'rotate(0deg)';
      });

      if (!isOpen) {
        contentEl.classList.add('open');
        contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
        titleEl.classList.add('active');
        if (arrowImg) arrowImg.style.transform = 'rotate(180deg)';
        console.log(`Opened: ${titleEl.textContent.trim()}`);
      } else {
        console.log(`Closed: ${titleEl.textContent.trim()}`);
      }
    });
  });

  const handleMenuActive = () => {
    const mobileMenu = document.querySelector("#mobile-ecom-menu");
    if (mobileMenu) {
      const li = mobileMenu.querySelectorAll("li");
      const firstli = mobileMenu.querySelector("li");
      if (li?.length) {
        li.forEach((ele) => {
          const panel = ele.querySelector(".ac-panel");
          if (panel) panel.style.height = 0;
          ele.classList.remove("is-active");
          ele.classList.remove("ac--open");
        });
      }
      if (firstli) {
        const panel = firstli.querySelector(".ac-panel");
        if (panel) panel.style.height = 0;
        firstli.classList.add("is-active");
        firstli.classList.add("ac--open");
      }
    }
  };

  window.addEventListener("load", () => {
    handleMenuActive();
  });

  const hamburger = document.getElementById("hamburger");
  if (hamburger) {
    hamburger.addEventListener("click", () => {
      handleMenuActive();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const navTab = document.querySelector("nav.header__ecom-menus");

  if (navTab) {
    document.querySelectorAll('a[data-child-menu]').forEach(link => {
      link.addEventListener("mouseenter", function () {
        const menuValue = this.getAttribute("data-child-menu");
        const matchingMenu = document.querySelector(`ul[data-child-menu="${menuValue}"]`);

        document.querySelectorAll('a[data-child-menu]').forEach(otherLink => {
          if (otherLink !== this) {
            otherLink.classList.remove("after:bg-navy");
          }
        });

        this.classList.add("after:bg-navy");

        navTab.classList.remove("invisible");

        if (!matchingMenu) {
          navTab.classList.add("invisible");
        }
      });

      link.addEventListener("mouseleave", function () {
        this.classList.remove("after:bg-navy");
      });
    });
  }
});
